const atan2 = Math.atan2
const cos = Math.cos
const sin = Math.sin
const PI = Math.PI
const sqrt = Math.sqrt
const R = 6378137

function toRad(x) {
  return (x * PI) / 180.0
}

//calcula a distância "em linha reta" entre 2 pontos, em metros
export function calculateHaversineDistanceMeters(a, b) {
  if (!a || !b) return
  const x1 = (b.latitude ?? b.lat ?? b[0]) - (a.latitude ?? a.lat ?? a[0])
  const dLat = toRad(x1)
  const x2 = (b.longitude ?? b.lng ?? b[1]) - (a.longitude ?? a.lng ?? a[1])
  const dLon = toRad(x2)

  const an =
    sin(dLat / 2) * sin(dLat / 2) +
    cos(toRad(a.latitude ?? a.lat ?? a[0])) *
      cos(toRad(b.latitude ?? b.lat ?? b[0])) *
      sin(dLon / 2) *
      sin(dLon / 2)
  const c = 2 * atan2(sqrt(an), sqrt(1 - an))
  const d = R * c
  return d
}

export function getWaypointsTotalDistance(waypoints) {
  if (typeof waypoints === 'string') waypoints = Array.from(JSON.parse(String(waypoints)))

  if (!waypoints.length) return 0

  let totalDistance = 0
  for (let i = 1; i < waypoints.length; i++) {
    let distanceBetween = calculateHaversineDistanceMeters(waypoints[i - 1], waypoints[i])
    totalDistance += distanceBetween
  }
  return totalDistance
}

// Calcula a menor distância entre um ponto e uma reta
export function perpendicularDistance(point, start, end) {
  const x0 = point[0],
    y0 = point[1]
  const x1 = start[0],
    y1 = start[1]
  const x2 = end[0],
    y2 = end[1]

  const num = Math.abs((y2 - y1) * x0 - (x2 - x1) * y0 + x2 * y1 - y2 * x1)
  const den = Math.sqrt(Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2))
  return num / den
}

// recebe um array de pontos e retorna um novo array com menos pontos representando o mesmo trajeto
export function douglasPeucker(waypoints, epsilon) {
  if (waypoints.length < 3) {
    return waypoints
  }

  let maxDistance = 0
  let index = 0
  const end = waypoints.length - 1
  for (let i = 1; i < end; i++) {
    const distance = perpendicularDistance(waypoints[i], waypoints[0], waypoints[end])
    if (distance > maxDistance) {
      maxDistance = distance
      index = i
    }
  }

  if (maxDistance > epsilon) {
    const left = douglasPeucker(waypoints.slice(0, index + 1), epsilon)
    const right = douglasPeucker(waypoints.slice(index), epsilon)

    return left.slice(0, -1).concat(right)
  } else {
    return [waypoints[0], waypoints[end]]
  }
}

export const metersToKms = (meters) => {
  return `${(meters / 1000).toFixed(2)}km`
}
